import React, { FC } from 'react';
import { FormControl, FormHelperText, InputLabel, Select } from '@material-ui/core';

interface Props {
  value?: string;
  error?: boolean;
  required?: boolean;
  className?: any;
  helperText?: string;
  onChange: (event: React.ChangeEvent<{ name?: string; value: unknown }>) => void;
}

const types = ['Incident', 'Paramétrage', 'Assistance', 'Production'];

const TicketTypeSelect: FC<Props> = React.forwardRef<any, Props>(
  ({ onChange, className, value, helperText, required, ...props }, ref) => {
    return (
      <FormControl
        ref={ref}
        className={className}
        variant='outlined'
        error={props.error}
        {...props}
        required={required}
        fullWidth
      >
        <InputLabel>Type de demande</InputLabel>
        <Select native label='Type de demande *' value={value} onChange={onChange}>
          <option value='' />
          {types.map((type, key) => (
            <option key={key} value={type}>
              {type}
            </option>
          ))}
        </Select>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    );
  }
);

export default TicketTypeSelect;
